import React from 'react';
import TimeTrackingAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/TimeTrackingAppIcon';

const TimesheetStrategy = {
  previewInfo: {
    name: 'Timesheet',
    iconSvg: <TimeTrackingAppIcon size="xlarge" />,
  },
};

export default TimesheetStrategy;
